import { PropsWithChildren } from "react";
import styles from "./ManagementTree.module.css";

const ManagementTreeItem = ({ children }: PropsWithChildren<{}>) => {
  return (
    <>
      <div
        className={`${styles.item} d-flex align-items-center px-2 py-2 app-shadow`}
      >
        {children}
      </div>
    </>
  );
};
export default ManagementTreeItem;
